import { gql } from 'apollo-boost';

export const newInvitation = gql`
  mutation newInvitation(
      $investmentId: Int!,
      $email: String!,
      $organization: String!,
      $firstName: String!,
      $lastName: String!,
      $message: String!,
      $automatic: Boolean,
      $datetime: String,
      $allowResend: Boolean
  ) {
    newInvitation(
      investmentId: $investmentId,
      email: $email,
      organization: $organization,
      firstName: $firstName,
      lastName: $lastName,
      message: $message,
      automatic: $automatic,
      datetime: $datetime,
      allowResend: $allowResend
  ) {
      success
      id
      alreadySent
      error
    }
  }
`;
